import React, { forwardRef, useCallback, useContext } from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// GLOBAL FUNCTIONS
import { doCallback } from 'functions';

// CONTEXT
import { DropdownContext } from 'core/tools/dropdown/helpers/dropdownContext';

// CORE COMPONENTS
import Button from 'core/tools/Button';
import Dropdown from 'core/tools/dropdown/Dropdown';

// LOCAL COMPONENTS
import AttachmentModal from './DocUprModal';

// STYLES
import styles from './attachmentDropdown.module.scss';

// CHILD COMPONENT
const UploadButton = ({
  onClick,
  ...props
}) => {

  // CONTEXT
  const { setShow } = useContext(DropdownContext) || {};

  // CALLBACKS
  const handleClick = useCallback(
    e => {
      doCallback(onClick, e);
      setShow(false);
    },
    [onClick, setShow]
  )

  // RENDER
  return (
    <Button
      onClick={handleClick}
      {...props}
    />
  )
}

// MAIN COMPONENT
const AttachmentDropdown = forwardRef(({
  className,
  label,
  disabled,
  onClick,
  useTemp,
  ...props
}, ref) => (<>
  <Dropdown
    toggle={{
      className: styles.toggle,
      label,
      disabled,
      justify: 'start'
    }}
    menu={{
      className: styles.menu
    }}
    align="start"
    useArrow={false}
  >
    <UploadButton
      {...props}
      variant="custom"
      className={clsx(
        styles.optionButton,
        className
      )}
      label="Upload File"
      icon={{
        use: 'upload',
        order: 1
      }}
      justify="start"
      onClick={onClick}
      ref={ref}
    />
    <AttachmentModal
      {...props}
      className={clsx(
        styles.optionButton
      )}
      variant="custom"
      label="Send Upload Link"
      icon={{
        use: 'email',
        order: 1
      }}
      justify="start"
      useTemp={useTemp}
    />
  </Dropdown>
</>))

// EXPORT
export default AttachmentDropdown;
